import { FormLayout } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import { useFormContext } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import LocalCombobox from "../Reusable/LocalCombobox";
import MultipleSelectField from "../Reusable/MultiSelectField";
import TextField from "../Reusable/TextInput";

const TypeData = [
  {
    name: "flat",
    id: "flat",
  },
  {
    name: "percentage",
    id: "percentage",
  },
];

export default ({
  isLoading,
  handleEdit,
  openAddReceiverPopup,
  setOpenAddReceiverPopup,
  openAddSenderPopup,
  setOpenAddSenderPopup,
  profile,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    watch,
    clearErrors,
    control,
  } = useFormContext();
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <div className={tw`grid sm:grid-cols-1 md:grid-cols-2 gap-x-4 mx-4`}>
        <TextField
          label={"PAN/VAT"}
          register={register("vat_pan")}
          errors={errors?.vat_pan}
        />
        <TextField
          label={"Code"}
          register={register("code")}
          errors={errors?.code}
        />
        <TextField
          label={"Short Code "}
          register={register("short_code")}
          errors={errors?.short_code}
        />
        <TextField
          label={"Exim Code"}
          register={register("exim_code")}
          errors={errors?.exim_code}
        />
        <TextField
          label={"Company Name"}
          register={register("company_name")}
          errors={errors?.company_name}
        />
        <MultipleSelectField
          queryKey={"service-type"}
          label={"Service Type"}
          register={register("service_type")}
          watch={watch}
          errors={errors?.service_type}
          setValue={setValue}
          clearErrors={clearErrors}
          props={{
            is_active: true,
          }}
          url={APIS.SERVICE_TYPE}
          value={profile?.service_type?.map((item: any, index: number) => ({
            label: item?.name,
            value: item?.id,
          }))}
        />
        <MultipleSelectField
          label={"Product Type"}
          queryKey={"product-type"}
          register={register("product_type")}
          watch={watch}
          setValue={setValue}
          errors={errors?.product_type}
          clearErrors={clearErrors}
          props={{
            is_active: true,
          }}
          url={APIS.PRODUCT_TYPE}
          value={profile?.product_type?.map((item: any, index: number) => ({
            label: item?.name,
            value: item?.id,
          }))}
        />
        <MultipleSelectField
          errors={errors?.payment_method}
          label={"Payment Method"}
          queryKey={"payment-method"}
          register={register("payment_method")}
          watch={watch}
          setValue={setValue}
          props={{
            is_active: true,
          }}
          url={APIS.PAYMENT_METHOD_TYPE}
          clearErrors={clearErrors}
          value={profile?.payment_method?.map((item: any, index: number) => ({
            label: item?.name,
            value: item?.id,
          }))}
        />
        <MultipleSelectField
          label={"Service Branch"}
          queryKey={"service-branch"}
          register={register("service_branch")}
          watch={watch}
          errors={errors?.service_branch}
          clearErrors={clearErrors}
          setValue={setValue}
          props={{
            is_active: true,
          }}
          url={APIS.BRANCH}
          value={profile?.service_branch?.map((item: any, index: number) => ({
            label: item?.name,
            value: item?.id,
          }))}
        />
        <MultipleSelectField
          label={"Destination city"}
          queryKey={"service-city"}
          register={register("service_city")}
          watch={watch}
          setValue={setValue}
          errors={errors?.service_city}
          clearErrors={clearErrors}
          url={`${APIS.LOCATION}flat-location/`}
          value={profile?.service_city?.map((item: any, index: number) => ({
            label: item?.name,
            value: item?.id,
          }))}
          props={{
            level: 3,
            is_active: true,
          }}
        />
        <ComboboxInput
          url={APIS.DELIVERY_CHARGE_TEMPLATE}
          props={{
            is_active: true,
            is_branch: false,
          }}
          queryKey={"delivery-charge-template"}
          register={register("delivery_charge_template")}
          errors={errors?.delivery_charge_template}
          name={"delivery_charge_template"}
          label={"Delivery Charge Template"}
          setValue={setValue}
          placeholder={"Search Delivery Charge Template"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <div>
          <div className={tw`grid grid-cols-2 gap-x-4 mt-2`}>
            <span>Default Sender</span>
          </div>
          <div className={tw`w-full flex items-start justify-center space-x-1`}>
            <div className={tw`w-full`}>
              <ComboboxInput
                url={APIS.CUSTOMER}
                props={{
                  is_active: true,
                }}
                queryKey={"customer"}
                register={register("default_sender")}
                errors={errors?.default_sender}
                name={"default_sender"}
                setValue={setValue}
                placeholder={"Search Default Sender"}
                getValues={getValues}
                clearErrors={clearErrors}
              />
            </div>
            <button
              className={tw`border px-4 py-1 text-xl mt-2 bg-[#EEF5F4] focus:outline-none`}
              type="button"
              onClick={() => setOpenAddSenderPopup(!openAddSenderPopup)}
            >
              +
            </button>
          </div>
        </div>
        <div>
          <div className={tw`grid grid-cols-2 gap-x-4 mt-2`}>
            <span>Default Receiver</span>
          </div>
          <div className={tw`w-full flex items-start justify-center space-x-1`}>
            <div className={tw`w-full`}>
              <ComboboxInput
                url={APIS.CUSTOMER}
                props={{
                  is_active: true,
                }}
                queryKey={"customer"}
                register={register("default_receiver")}
                errors={errors?.default_receiver}
                name={"default_receiver"}
                setValue={setValue}
                placeholder={"Search Default Receiver"}
                getValues={getValues}
                clearErrors={clearErrors}
              />
            </div>
            <button
              className={tw`border px-4 py-1 text-xl mt-2 bg-[#EEF5F4] focus:outline-none`}
              type="button"
              onClick={() => setOpenAddReceiverPopup(!openAddReceiverPopup)}
            >
              +
            </button>
          </div>
        </div>

        <ComboboxInput
          url={APIS.PRODUCT_TYPE}
          props={{
            is_active: true,
          }}
          queryKey={"product-type"}
          register={register("default_product_type")}
          errors={errors?.default_product_type}
          name={"default_product_type"}
          label={"Default Product Type"}
          setValue={setValue}
          placeholder={"Search Default Product Type"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          url={APIS.PAYMENT_METHOD_TYPE}
          props={{
            is_active: true,
          }}
          queryKey={"payment-method-type"}
          register={register("default_payment_method")}
          errors={errors?.default_payment_method}
          name={"default_payment_method"}
          label={"Default Payment Method"}
          setValue={setValue}
          placeholder={"Search Default Payment Method"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          url={APIS.SERVICE_TYPE}
          props={{ is_active: true }}
          queryKey={"service-type"}
          register={register("default_service_type")}
          errors={errors?.default_service_type}
          name={"default_service_type"}
          label={"Default Service Type"}
          setValue={setValue}
          placeholder={"Search Default Service Type"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <LocalCombobox
          label={"Charge Type"}
          placeholder={"Search charge type"}
          props={{}}
          control={control}
          errors={errors?.charge_type}
          name={"charge_type"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          data={TypeData}
        />
        <TextField
          label={"Charge Rate"}
          register={register("charge")}
          errors={errors?.charge}
        />
        <TextField
          label={"St. Charge "}
          register={register(`st_charge`)}
          errors={errors?.st_charge}
        />
      </div>
    </FormLayout>
  );
};
